import { createContext, useContext } from 'react';

/**
 * Whether the person may change things in the workspace they are in (spec 188/189):
 * false only for someone reading an Organization workspace they are not a member of.
 *
 * A context, provided once by the workspace layout, because the controls it takes away
 * sit far below any component that reads the workspace — a card's menu, a comment box,
 * an upload button. `true` without a provider, so a component rendered on its own (and
 * every test that does so) keeps every control. The service refuses regardless (spec
 * 151); this decides only what is offered.
 */
export const CanWorkContext = createContext<boolean>(true);

export function useCanWork(): boolean {
  return useContext(CanWorkContext);
}
